module.exports = __webpack_public_path__ + "img/sx.930399fc.png";